<div class="banner-carousel" [class.loaded]="false">
  <div class="banner-skeleton"></div>
  <app-my-carousel-swiper [config]="carouselOptions" [class]="'carousel-' + design">
    <div class="swiper-slide" *ngFor="let image of images; let i = index">
      <img loading="lazy" (load)="loadImg()" (click)="redirectLink(image?.url)" [src]="getImageSrc(local, image)" alt="Slide {{ i + 1 }}" />
    </div>
  </app-my-carousel-swiper>
</div>
